export {
  PropertyAgentInfo,
  type PropertyAgentInfoProps,
} from "./PropertyAgentInfo";
export { default } from "./PropertyAgentInfo";
